{% block sw_settings_payment_detail_content_field_active %}
<mt-switch
    v-if="!acl.can('payment.editor') || paymentMethod && needsOnboarding"
    v-model="paymentMethod.active"
    v-tooltip.left="{ message: $t('swag-paypal-method.paymentActivateSwitchTooltip') }"
    class="sw-settings-payment-detail__field-active"
    :disabled="!paymentMethod.active"
    :label="$t('sw-settings-payment.detail.labelActive')"
/>

<template v-else>
    {% parent %}
</template>
{% endblock %}
